import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaEdit, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { FHOST } from '../constants/Functions';

const MyLessons = ({userInfo}) => {
  const [videos, setVideos] = useState([]); // Initialize as an array
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedVideo, setExpandedVideo] = useState(null);
   const [successMessage,setSuccessMessage]=useState("")
   const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    // Fetch videos from the API
    axios
      .get(`${FHOST}/lessons/api/videos/teacher/${userInfo?.id}`)
      .then((response) => {
        // Access the videos array from the response
        const videoData = response.data.videos || []; // Default to an empty array if not found
        setVideos(videoData);
      })
      .catch((error) => console.error('Error fetching videos:', error));
  }, []);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const toggleDescription = (id) => {
    setExpandedVideo((prev) => (prev === id ? null : id));
  };

  // Filter videos based on the search query
  const filteredVideos = videos.filter(
    (video) =>
      video.title.toLowerCase().includes(searchQuery) ||
      (video.description && video.description.toLowerCase().includes(searchQuery))
  );

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-4">My Lessons</h1>
      <input
        type="text"
        placeholder="Search videos..."
        value={searchQuery}
        onChange={handleSearch}
        className="mb-4 p-2 border border-gray-300 rounded w-full"
      />
      <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {filteredVideos.map((video) => (
          <div key={video.id} className="p-4 bg-white rounded shadow">
            <h2 className="text-lg font-semibold">{video.title}</h2>
            <div className="relative w-full pb-[56.25%] bg-gray-200 rounded overflow-hidden">
              <video
                src={`${video.video_url}`}
                controls
                className="absolute top-0 left-0 w-full h-full"
              />
            </div>
            <div className="flex justify-between items-center mt-2">
              <button
                onClick={() => toggleDescription(video.id)}
                className="text-white text-sm flex items-center w-fit"
              >
                {expandedVideo === video.id ? (
                  <>
                    <FaChevronUp className="mr-2" /> Hide Description
                  </>
                ) : (
                  <>
                    <FaChevronDown className="mr-2" /> Show Description
                  </>
                )}
              </button>
              <button className="text-green-800 text-sm flex items-center w-fit">
                <FaEdit className="mr-2" />
              </button>
            </div>
            {expandedVideo === video.id && (
              <p className="mt-2 text-gray-700">{video.description}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyLessons;
